import { useFormContext, useWatch } from 'react-hook-form';
import styles from 'styles/pages/mypage/MypageInfoForm.module.scss';
import { useMutation } from 'react-query';
import { FormCheckMsgs } from 'types/components/form';
import { useEffect } from 'react';
import { isTCustomAxiosError } from 'apis/config/axios';
import LabelInput from 'components/common/forms/LabelInput';
import { postDupCheckEmail } from 'apis/mypage';
import { UserRoleType } from 'types/apis/auth';
import { MypageInfoFormFields, TMypageInfoForm } from 'types/form/mypage';
import { STYLES_VARIABLES } from 'constants/styleVariables';

type TProps = {
  disabled?: boolean;
  checkAvailability: boolean;
  email?: string;
  dupCheckEmailMsg: string | null;
  setDupCheckEmailMsg: (msg: string | null) => void;
};

const Email = ({
  disabled,
  checkAvailability,
  email,
  dupCheckEmailMsg,
  setDupCheckEmailMsg,
}: TProps) => {
  const isProfessorPage = location.pathname.includes('professor');

  const { formState, control } = useFormContext<TMypageInfoForm>();
  const emailError =
    isTCustomAxiosError(formState.errors.email) && formState.errors.email;

  const emailValue = useWatch({
    name: MypageInfoFormFields.Email,
    control,
  });

  const { mutate: dupCheckEmailMutation } = useMutation(postDupCheckEmail, {
    onSuccess: (data) => {
      if (data === null) {
        setDupCheckEmailMsg(FormCheckMsgs.InvalidInputValue);
      }
      if (!data.data) {
        setDupCheckEmailMsg(FormCheckMsgs.AvailableEmail);
      } else {
        setDupCheckEmailMsg(FormCheckMsgs.AlreadyExistEmail);
      }
    },
  });

  const onClickDupCheckEmail = () => {
    if (emailValue) {
      setDupCheckEmailMsg(
        emailValue === email ? FormCheckMsgs.AvailableEmail : null
      );
      if (emailValue !== email) {
        dupCheckEmailMutation({
          email: emailValue,
          userRole: isProfessorPage
            ? UserRoleType.PROFESSOR
            : UserRoleType.STUDENT,
        });
      }
    }
  };

  useEffect(() => {
    setDupCheckEmailMsg(null);
  }, [email]);

  const commonProps = {
    labelText: '이메일',
    placeholderText: '자주 사용하는 이메일을 입력해 주세요.',
    name: MypageInfoFormFields.Email,
    required: true,
    disabled,
  };

  return (
    <>
      <LabelInput
        {...commonProps}
        checkAvailability={checkAvailability}
        btnText="중복확인"
        onBtnClick={onClickDupCheckEmail}
        inputStyle={
          !checkAvailability
            ? { backgroundColor: STYLES_VARIABLES.GRAY_01 }
            : {}
        }
        rules={
          checkAvailability
            ? {
                required: '이메일을 입력해 주세요.',
                pattern: {
                  value: /^[a-zA-Z0-9+-_.]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                  message: FormCheckMsgs.InvalidInputValue,
                },
              }
            : {}
        }
      />

      {!emailError && dupCheckEmailMsg === null && (
        <div className={styles.div}></div>
      )}
      {emailError && checkAvailability && (
        <p className="error_text">{emailError?.message}</p>
      )}
      {!emailError && checkAvailability && dupCheckEmailMsg && (
        <p
          className={`error_text ${
            dupCheckEmailMsg === FormCheckMsgs.AvailableEmail
              ? 'purple_text'
              : ''
          }`}
        >
          {dupCheckEmailMsg}
        </p>
      )}
    </>
  );
};

export default Email;
